module.exports = __webpack_public_path__ + "media/newstyle/images/audio_file-d9e0a5ca8500e80a211a589dbb814c51.svg";